function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M197.42,39.26c21.48-2.1,36.75,11.18,36.83,31.2.17,46,.15,130.58,0,176.59-.06,18.71-13.46,31.86-32.08,31.89q-64.21.1-128.42,0c-18.12,0-31.92-13.43-32-31.48-.17-46.23-.17-131,0-177.23.06-17,13.28-30.92,29.34-31.41,2-.06,6.24-1.25,5.78,1.26-.6,3.21.15,8.57-5.58,9.26a20.51,20.51,0,0,0-12.57,5.81,19.64,19.64,0,0,0-6,14.37c0,46.66-.08,131.86.05,178.52,0,12.42,8.84,20.24,22.36,20.3,21,.09,42,0,62.93,0q31.14,0,62.28,0c15.16,0,23.42-8.2,23.43-23.4,0-44.73,0-128,0-172.74,0-13-5.94-20.55-18.7-22.78C198.68,48.34,201.64,42.39,197.42,39.26Z"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "92.47 134.83 70.92 110.2 78.65 103.43 93.08 119.91 120.44 93.36 127.6 100.73 92.47 134.83"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 133.88,
  y: 115.81,
  width: 69.38,
  height: 12.85,
  rx: 6.42,
  ry: 6.42
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 133.88,
  y: 161.42,
  width: 69.38,
  height: 12.85,
  rx: 6.42,
  ry: 6.42
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 133.88,
  y: 213.45,
  width: 69.38,
  height: 12.85,
  rx: 6.42,
  ry: 6.42
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M106.74,183.26H90.36A7.24,7.24,0,0,1,83.14,176V159.65a7.24,7.24,0,0,1,7.23-7.23h16.38a7.24,7.24,0,0,1,7.23,7.23V176A7.24,7.24,0,0,1,106.74,183.26Zm-16.38-25.7a2.09,2.09,0,0,0-2.09,2.09V176a2.09,2.09,0,0,0,2.09,2.09h16.38a2.09,2.09,0,0,0,2.09-2.09V159.65a2.09,2.09,0,0,0-2.09-2.09Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M107.39,235.29H91a7.24,7.24,0,0,1-7.23-7.23V211.68A7.24,7.24,0,0,1,91,204.46h16.38a7.24,7.24,0,0,1,7.23,7.23v16.38A7.24,7.24,0,0,1,107.39,235.29ZM91,209.6a2.09,2.09,0,0,0-2.09,2.09v16.38A2.09,2.09,0,0,0,91,230.15h16.38a2.09,2.09,0,0,0,2.09-2.09V211.68a2.09,2.09,0,0,0-2.09-2.09Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M191.2,48.61a21.23,21.23,0,0,0-4.7-8.3c-6.84-8.11-16.11-11.77-26-14.15-2.71-.65-4.49-1.12-5-4.48-1-5.82-4.64-10-10-12.49a22.66,22.66,0,0,0-14.19-.11c-3.63,1.21-7.34,3.58-8,6.86-2,9.69-9.71,10.69-17,13.13A36,36,0,0,0,89,41a18.87,18.87,0,0,0-4.33,9.17c-.94,7,1.07,9.41,8.25,9.42q45,.05,89.91,0C190.69,59.56,193.18,56.26,191.2,48.61Zm-53-15a8.35,8.35,0,1,1,8.35-8.35A8.35,8.35,0,0,1,138.17,33.58Z"
});

var SvgLogistics = function SvgLogistics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 276 287",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogistics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logistics.e40a7060.svg";
export { ForwardRef as ReactComponent };